import { Component, Input } from '@angular/core';
import { BildungsangebotTerminDetail, Termin } from '../../model';
import { getDauerKurzbezeichnungWithTimeRefence } from '../../model/dauer';

import { DurationPipe } from '../../shared/pipes/duration/duration.pipe';

@Component({
  selector: 'now-wbsuche-lib-dauer-anzeige',
  templateUrl: './dauer-anzeige.component.html',
  imports: [DurationPipe]
})
export class DauerAnzeigeComponent {
  @Input()
  public termin!: Termin | BildungsangebotTerminDetail;

  getDauerKurzbezeichnung = (id: number) => getDauerKurzbezeichnungWithTimeRefence(id)?.label;
}
